import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchCareerProfile } from "./CareerProfileAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchCareerProfileAsync = createAsyncThunk(
  "CareerProfile/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchCareerProfile();

      const resp = data?.response;
      if (!resp) {
        throw new Error("Invalid response structure");
      }
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const CareerProfileSlice = createSlice({
  name: "CareerProfile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCareerProfileAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCareerProfileAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("data", action.payload);
        state.error = null;
      })
      .addCase(fetchCareerProfileAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const selectCareerProfile = (state) => state.careerProfile.data;

export default CareerProfileSlice.reducer;
